// extracted by mini-css-extract-plugin
export default {"blueCell":"BlueCell_blueCell__rM7np"};